<template>
  <div>
    <DeliveredCompanyProfile
      :lgSize="12"
      :lgOffset="0"
      :locParam="1"
      :idCity="0"
      :details="0"
      :title="company"
      :dFrom="date_from"
      :dTo="date_to"
    ></DeliveredCompanyProfile>
    <DeliveredCompanyTable
      :dFrom="date_from"
      :dTo="date_to"
      :title="company"
    ></DeliveredCompanyTable>
  </div>
</template>

<script>
import DeliveredCompanyProfile from "../../../components/company-profile/DeliveredCompanyProfile";
import DeliveredCompanyTable from "../../../components/company-profile/DeliveredCompanyTable";

export default {
  name: "CompanyProfile",
  props: ["company", "date_from", "date_to"],
  components: {
    DeliveredCompanyProfile,
    DeliveredCompanyTable
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
